import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import Home from "./Home";
import AddListing from "./AddListing";
import ViewListings from "./ViewListings";
import EditListing from "./EditListing";
import ManageCampaigns from "./ManageCampaigns";
import "../styles/Dashboard.css";

const Dashboard = () => {
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState("Home");
  const [editListingId, setEditListingId] = useState(null);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  // Handler for when a listing edit is requested
  const handleEditListing = (listingId) => {
    console.log("Dashboard received edit request for listing:", listingId);
    setEditListingId(listingId);
    // No need to change activePage - we'll handle this in renderPage
  };

  // Handler to go back from edit page to listings
  const handleBackFromEdit = () => {
    setEditListingId(null);
    setActivePage("ViewListings");
  };

  const renderPage = () => {
    // If we have an editListingId, show the edit form regardless of activePage
    if (editListingId) {
      return <EditListing 
               listingId={editListingId} 
               onBack={handleBackFromEdit} 
             />;
    }
    
    // Otherwise show the usual pages based on activePage
    switch (activePage) {
      case "Home":
        return <Home />;
      case "AddListing":
        return <AddListing />;
      case "ViewListings":
        return <ViewListings onEditListing={handleEditListing} />;
      case "ManageCampaigns":
        return <ManageCampaigns />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="dashboard-container">
      {/* Sidebar Navigation */}
      <nav className="sidebar">
        <h2 className="logo">MarketBot</h2>
        <ul>
          <li 
            className={activePage === "Home" && !editListingId ? "active" : ""} 
            onClick={() => {setActivePage("Home"); setEditListingId(null);}}
          >
            🏠 Home
          </li>
          <li 
            className={activePage === "AddListing" && !editListingId ? "active" : ""} 
            onClick={() => {setActivePage("AddListing"); setEditListingId(null);}}
          >
            ➕ Add Listing
          </li>
          <li 
            className={(activePage === "ViewListings" && !editListingId) || editListingId ? "active" : ""} 
            onClick={() => {setActivePage("ViewListings"); setEditListingId(null);}}
          >
            📜 {editListingId ? "Edit Listing" : "View Listings"}
          </li>
          <li 
            className={activePage === "ManageCampaigns" && !editListingId ? "active" : ""} 
            onClick={() => {setActivePage("ManageCampaigns"); setEditListingId(null);}}
          >
            ⚙️ Manage Campaigns
          </li>
          <li className="logout" onClick={handleLogout}>🚪 Logout</li>
        </ul>
      </nav>

      {/* Main Content Area */}
      <main className="content-area">
        {renderPage()}
      </main>
    </div>
  );
};

export default Dashboard;